import axios from 'axios';
import apiClient from './api.service';
import {
  ResponseSubmit,
  ResponseResult,
  EligibilityCheck,
  ResponseData,
} from '../types/response.types';

// Phase 6 - US4: Response Service (T112)

export const responseService = {
  async submitResponse(data: ResponseSubmit, guestToken?: string): Promise<ResponseResult> {
    const config = guestToken ? { headers: { Authorization: `Bearer ${guestToken}` } } : {};
    const response = await apiClient.post('/api/responses', data, config);
    
    // Suporta ambos os formatos de resposta:
    // Formato padrão: { data: { responseHash, submittedAt }, message }
    // Formato legado: { success, responseHash, message }
    let result;
    
    if (response.data?.data) {
      // Formato padrão com wrapper 'data'
      result = response.data.data;
    } else if (response.data?.responseHash) {
      // Formato legado direto
      result = {
        responseHash: response.data.responseHash,
        submittedAt: response.data.submittedAt || new Date().toISOString(),
      };
    } else {
      throw new Error('Resposta inválida do servidor: dados de resposta não recebidos');
    }
    
    if (!result.responseHash) {
      throw new Error('Resposta incompleta: faltam campos obrigatórios');
    }
    
    return result;
  },

  async getResponseByHash(hash: string): Promise<ResponseData> {
    const response = await apiClient.get(`/api/responses/${hash}`);
    return response.data.data;
  },

  async checkEligibility(surveyId: string): Promise<EligibilityCheck> {
    try {
      const response = await apiClient.get(`/api/surveys/${surveyId}/eligibility`);
      return response.data.data;
    } catch (error: unknown) {
      if (axios.isAxiosError(error)) {
        const message =
          error.response?.data?.message ||
          error.response?.data?.error ||
          'Você não é elegível para esta pesquisa.';

        return {
          eligible: false,
          reason: message,
        };
      }

      return {
        eligible: false,
        reason: 'Não foi possível verificar sua elegibilidade para esta pesquisa.',
      };
    }
  },

  async getResponseAudit(surveyId: string | number) {
    const response = await apiClient.get(`/api/responses/audit/${surveyId}`);
    return response.data.data;
  },

  async getResponseAuditByHash(hash: string) {
    const response = await apiClient.get(`/api/responses/audit/hash/${hash}`);
    return response.data.data;
  },
};

export default responseService;
